import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Modal,
  Select,
  Switch,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import CloseIcon from "@mui/icons-material/Close";
import SearchBar from "components/SearchBar";
import CorporateAccounts from "features/activeSubscriptions/CorporateAccounts";
import IndividualSubscriptions from "features/activeSubscriptions/IndividualSubscriptions";
import InvoiceAndPayments from "features/activeSubscriptions/InvoiceAndPayments";
import MainContainer from "layout/MainContainer";
import { ConfirmationModal } from "Modals/confirmationModal";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Listing } from "types/General";
import { isValidInput } from "utils/validations";
import { useLazyDeleteSubscriptionQuery, useLazyGetAllSubscriptionQuery } from "service/subscription";
import { showError, showToast } from "helpers";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

const ActiveSubscriptions = () => {
  const navigate = useNavigate();
  const [valueTabs, setValueTabs] = React.useState(0);
  const label = { inputProps: { "aria-label": "Switch demo" } };

  const [searchTerm, setSearchTerm] = useState<string>("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [selectedId, setSelectedId] = useState("");
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openAccount, setOpenAccount] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [subscriptionData, setsubScriptionData] = useState<any[]>([]);
  const [getAllSubscription] = useLazyGetAllSubscriptionQuery();
  const [deleteSubscription] = useLazyDeleteSubscriptionQuery();


  const getSubscriptionApi = async () => {
    setLoading(true);
    try {
      const response = await getAllSubscription({
        page: page,
        search: debouncedSearchTerm,
      }).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        setsubScriptionData(response?.data);
        setCount(response?.data?.totalCount);
        setPage(response?.data?.currentPage);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };
  const deleteVehicleApi = async (id: string) => {
    setLoading(true);
    try {
      const response = await deleteSubscription({
        id,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        getSubscriptionApi();
        showToast(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
    }
  };

  useEffect(() => {
    getSubscriptionApi();
  }, []);


  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);

  const handleClick1 = (
    event: React.MouseEvent<HTMLButtonElement>,
    rowId: string
  ) => {
    setAnchorEl1(event.currentTarget);
    setSelectedId(rowId);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
    setSelectedId("");
  };

  const columns: GridColDef[] = [
    {
      flex: 0.4,
      minWidth: 100,
      field: "name",
      headerName: "Plan Name",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>Monthly</p>
          </div>
        );
      },
    },

    {
      flex: 0.4,
      minWidth: 100,
      field: "duration",
      headerName: "Duration",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>7 Days</p>
          </div>
        );
      },
    },

    {
      flex: 0.4,
      minWidth: 100,
      field: "price",
      filterable: false,
      sortable: false,
      headerName: "Pricing",
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>AED 2000</p>
          </div>
        );
      },
    },

    {
      flex: 0.4,
      minWidth: 100,
      field: "category",
      filterable: false,
      sortable: false,
      headerName: "Vehicle Category",
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>Suv</p>
          </div>
        );
      },
    },
    {
      flex: 0.4,
      minWidth: 100,
      field: "limit",
      filterable: false,
      sortable: false,
      headerName: "Mileage Limit",
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>200km/day</p>
          </div>
        );
      },
    },
    {
      flex: 0.4,
      minWidth: 100,
      field: "location",
      filterable: false,
      sortable: false,
      headerName: "Allowed Locations",
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>Global</p>
          </div>
        );
      },
    },
    {
      flex: 0.4,
      minWidth: 100,
      field: "method",
      filterable: false,
      sortable: false,
      headerName: "Payment Methods",
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>Crypto</p>
          </div>
        );
      },
    },
    {
      flex: 0.4,
      minWidth: 150,
      field: "status",
      filterable: false,
      sortable: false,
      headerName: "Status",
      renderCell: ({ row }) => {
        return (
          <Switch
            {...label}
            size="small"
            checked={row?.isBlocked}
          // onChange={() => handleStatusUpdate(row?._id, !row?.isBlocked)}
          />
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 80,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                aria-controls={open1 ? "basic-menu1" : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? "true" : undefined}
                onClick={(event) => handleClick1(event, row._id)}
              >
                <img src="/static/images/more_icon.svg" alt="" />
              </IconButton>
              <Menu
                className="setting_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  "aria-labelledby": "basic-button1",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.05)",
                    borderRadius: "8px",
                    mt: 1,
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem
                  onClick={() => {
                    navigate("/subscriptions/manage-subscriptions/edit/1");
                    handleClose1();
                  }}
                >
                  Edit
                </MenuItem>

                <MenuItem
                  onClick={() => {
                    handleClose1();
                  }}
                >
                  Delete
                </MenuItem>
              </Menu>
            </Box>
          </div>
        );
      },
    },
  ];

  const dummyListings: Listing[] = [
    {
      _id: "1",
      title: "Honda Civic 2020",
      vehicleType: 1,
      coverImage: "/static/images/vehicle_side.jpg",

      soldStatus: 0,
      image: [],
      isBlocked: false,
      status: 0,
      isPremiumCar: false,
    },
    {
      _id: "2",
      title: "Yamaha R15 V3",
      vehicleType: 1,
      coverImage: "/static/images/vehicle_side.jpg",

      soldStatus: 0,
      image: [],
      isBlocked: false,
      status: 0,
      isPremiumCar: false,
    },
    {
      _id: "3",
      title: "Tata 407 Mini Truck",
      vehicleType: 1,
      coverImage: "/static/images/vehicle_side.jpg",

      soldStatus: 0,
      image: [],
      isBlocked: false,
      status: 0,
      isPremiumCar: false,
    },
    {
      _id: "4",
      title: "Volvo FH16 Heavy Duty",
      vehicleType: 2,
      coverImage: "/static/images/vehicle_side.jpg",

      soldStatus: 0,
      image: [],
      isBlocked: false,
      status: 0,
      isPremiumCar: false,
    },
  ];

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Managing Active Subscriptions</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Active
          Subscriptions
        </p>
      </div>

      <div className="stats_boxes gap_m" style={{ marginBottom: "30px" }}>
        <div
          className="cards"
        // onClick={() => navigate("/dashboard/registered-users")}
        >
          <figure>
            <img
              src="/static/images/active_subscription.png"
              alt=""
              style={{ height: "30px", width: "30px" }}
            />
          </figure>
          <h2>{200}</h2>
          <p>Active Subscriptions</p>
        </div>

        <div
          className="cards"
        // onClick={() => navigate("/dashboard/registered-users")}
        >
          <figure>
            <img
              src="/static/images/warning.png"
              alt=""
              style={{ height: "30px", width: "30px" }}
            />
          </figure>
          <h2>{80}</h2>
          <p>Expiring soon</p>
        </div>

        <div
          className="cards"
        // onClick={() => navigate("/dashboard/registered-users")}
        >
          <figure>
            <img
              src="/static/images/cross.png"
              alt=""
              style={{ height: "30px", width: "30px" }}
            />
          </figure>
          <h2>{40}</h2>
          <p>Expired</p>
        </div>

        <div
          className="cards"
        // onClick={() => navigate("/dashboard/registered-users")}
        >
          <figure>
            <img
              src="/static/images/increase.png"
              alt=""
              style={{ height: "30px", width: "30px" }}
            />
          </figure>
          <h2>$ 20,000</h2>
          <p>Total Revenue</p>
        </div>
      </div>

      <div className="cards">
        <Box className="custom_tabs" sx={{ width: "100%" }}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  placeholder="Search"
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm("")}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </Box>
            </div>
            <div className="right_s">
              <Box>
                <Button
                  className="btn btn_orange"
                  onClick={() =>
                    navigate("/subscriptions/manage-subscriptions/add")
                  }
                >
                  Add New Subscription
                </Button>
              </Box>
            </div>
          </div>

          <Tabs
            value={valueTabs}
            onChange={handleChangeTabs}
            aria-label="basic tabs example"
            className="custom_tabs_links"
          >
            <Tab label="Individual Subscriptions" {...a11yProps(0)} />
            <Tab label="Corporate Accounts" {...a11yProps(1)} />
            <Tab label="Invoices & Payments" {...a11yProps(2)} />
          </Tabs>

          <CustomTabPanel value={valueTabs} index={0}>
            <div className="sorting_table">
              <IndividualSubscriptions
                onCancel={() => setOpenCancel(true)}
                count={count}
                rows={subscriptionData}
                page={page}
                onPageChange={handlePageChange}
                loading={loading}
              />
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={1}>
            <div className="sorting_table">
              <CorporateAccounts
                onManage={() => setOpenAccount(true)}
                count={count}
                rows={dummyListings}
              />
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={2}>
            <div className="sorting_table">
              <InvoiceAndPayments count={count} rows={dummyListings} />
            </div>
          </CustomTabPanel>
        </Box>
      </div>
      <ConfirmationModal
        text={"Are you sure you want to cancel John's Subscription"}
        openModal={openCancel}
        setOpenModal={setOpenCancel}
        handleSubmit={() => {
          setOpenCancel(false);
        }}
      />
      <Modal
        className="modal addNotification_modal"
        id="addNotificationModal"
        aria-labelledby="addNotification-modal-title"
        aria-describedby="addNotification-modal-description"
        open={openEdit}
        onClose={() => setOpenEdit(false)}
      >
        <div className="modal-dialog">
          <div className="modal-body">
            <div className="btn-close" onClick={() => setOpenEdit(false)}>
              <CloseIcon />
            </div>
            <div className="modal_title">
              <h2>Manage Subscription - John Doe</h2>
            </div>
            <form className="form" action="">
              <div className="gap_p">
                <div className="control_group w_50">
                  <label>Investment Plan</label>
                  <Select
                    fullWidth
                    value={"default"}
                    // onChange={handleChange1}
                    label="Select User"
                  // disabled={selectAll}
                  >
                    <MenuItem value="default" disabled>
                      Select Plan
                    </MenuItem>
                    <MenuItem value="Individual">Gold Plan</MenuItem>
                    <MenuItem value="Dealer">Silver Plan</MenuItem>
                  </Select>
                </div>

                <div className="control_group w_50">
                  <label>Status</label>
                  <Select
                    fullWidth
                    value={"default"}
                    // onChange={handleChange1}
                    label="Select User"
                  // disabled={selectAll}
                  >
                    <MenuItem value="default" disabled>
                      Status
                    </MenuItem>
                    <MenuItem value="active">Active</MenuItem>
                  </Select>
                </div>

                <div className="control_group w_50">
                  <label>Start Date</label>
                  <TextField
                    name="startDate"
                    type="date"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                  // value={formik.values.startDate}
                  // inputProps={{
                  //   min: new Date().toISOString().split("T")[0],
                  // }}
                  // onChange={(e) => {
                  //   const value = e.target.value;
                  //   const year = value.split("-")[0]; // Extract year
                  //   if (year.length > 4) return; // Prevent input if year exceeds 4 digits
                  //   formik.handleChange(e); // Update Formik state
                  // }}
                  // error={
                  //   formik.touched.startDate &&
                  //   Boolean(formik.errors.startDate)
                  // }
                  // helperText={
                  //   formik.touched.startDate && formik.errors.startDate
                  // }
                  />
                </div>

                <div className="control_group w_50">
                  <label>End Date</label>
                  <TextField
                    name="startDate"
                    type="date"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                  // value={formik.values.startDate}
                  // inputProps={{
                  //   min: new Date().toISOString().split("T")[0],
                  // }}
                  // onChange={(e) => {
                  //   const value = e.target.value;
                  //   const year = value.split("-")[0]; // Extract year
                  //   if (year.length > 4) return; // Prevent input if year exceeds 4 digits
                  //   formik.handleChange(e); // Update Formik state
                  // }}
                  // error={
                  //   formik.touched.startDate &&
                  //   Boolean(formik.errors.startDate)
                  // }
                  // helperText={
                  //   formik.touched.startDate && formik.errors.startDate
                  // }
                  />
                </div>
              </div>

              <div className="footer_btn_flex">
                <Button
                  className="btn btn_highlight"
                  onClick={() => setOpenEdit(false)}
                >
                  Cancel
                </Button>
                <Button
                  className="btn btn_secondary"
                  onClick={() => setOpenEdit(false)}
                >
                  Submit
                </Button>
              </div>
            </form>
          </div>
        </div>
      </Modal>

      <Modal
        className="modal addNotification_modal"
        id="addNotificationModal"
        aria-labelledby="addNotification-modal-title"
        aria-describedby="addNotification-modal-description"
        open={openAccount}
        onClose={() => setOpenAccount(false)}
      >
        <div className="modal-dialog">
          <div className="modal-body">
            <div className="btn-close" onClick={() => setOpenAccount(false)}>
              <CloseIcon />
            </div>
            <div className="modal_title">
              <h2>Manage Corporate Account - TechCorp inc.</h2>
            </div>
            <form className="form" action="">
              <div className="gap_p">
                <div className="control_group w_50">
                  <label>Cars Allocated</label>
                  <TextField
                    variant="outlined"
                    placeholder="Cars Allocated"
                    fullWidth
                    hiddenLabel
                  // value={title}
                  // onChange={(e) => setTitle(e.target.value)}
                  // onFocus={() => setError(false)}
                  />
                </div>

                <div className="control_group w_50">
                  <label>Account Manager</label>
                  <Select
                    fullWidth
                    value={"default"}
                    // onChange={handleChange1}
                    label="Select User"
                  // disabled={selectAll}
                  >
                    <MenuItem value="default" disabled>
                      Select Manager
                    </MenuItem>
                    <MenuItem value="Individual">Mark</MenuItem>
                    <MenuItem value="Dealer">James</MenuItem>
                  </Select>
                </div>

                <div className="control_group w_50">
                  <label>Billing Cycle</label>
                  <Select
                    fullWidth
                    value={"default"}
                    // onChange={handleChange1}
                    label="Select User"
                  // disabled={selectAll}
                  >
                    <MenuItem value="default" disabled>
                      Monthly
                    </MenuItem>
                    <MenuItem value="active">Yearly</MenuItem>
                  </Select>
                </div>

                <div className="control_group w_50">
                  <label>Next Billing Date</label>
                  <TextField
                    name="Billing Date"
                    type="date"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                  // value={formik.values.startDate}
                  // inputProps={{
                  //   min: new Date().toISOString().split("T")[0],
                  // }}
                  // onChange={(e) => {
                  //   const value = e.target.value;
                  //   const year = value.split("-")[0]; // Extract year
                  //   if (year.length > 4) return; // Prevent input if year exceeds 4 digits
                  //   formik.handleChange(e); // Update Formik state
                  // }}
                  // error={
                  //   formik.touched.startDate &&
                  //   Boolean(formik.errors.startDate)
                  // }
                  // helperText={
                  //   formik.touched.startDate && formik.errors.startDate
                  // }
                  />
                </div>
              </div>

              <div className="footer_btn_flex">
                <Button
                  className="btn btn_highlight"
                  onClick={() => setOpenEdit(false)}
                >
                  Cancel
                </Button>
                <Button
                  className="btn btn_secondary"
                  onClick={() => setOpenEdit(false)}
                >
                  Submit
                </Button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    </MainContainer>
  );
};

export default ActiveSubscriptions;
